export default __webpack_public_path__ + "static/media/blue.b71a988b.webp";